import { useRef, useLayoutEffect } from 'react';
import { TabPanel as AriaTabPanel } from 'react-aria-components';
import type { TabPanelProps as AriaTabPanelProps } from 'react-aria-components';



interface TabPanelProps extends AriaTabPanelProps {
	selectedOrderUnvId: string | null;
}


export const TabPanel = (props: TabPanelProps) => {
	const { selectedOrderUnvId, children, className, ...otherProps } = props;

	const tabPanelRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		if (tabPanelRef && tabPanelRef.current) {
			tabPanelRef.current.scrollTo({ top: 0 });
		}
	}, [ tabPanelRef, selectedOrderUnvId ]);
	
	return (
		<AriaTabPanel {...otherProps} className={`react-aria-TabPanel${className ? ` ${className}` : ''}`} ref={tabPanelRef}>
			{children}
		</AriaTabPanel>
	);
};